// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import api from './advisorApi';
import type { Note, NoteCreateDTO, NoteUpdateDTO } from '../types/note';

export const noteApi = {
  getRelationshipNotes: async (profileId: string): Promise<Note[]> => {
    const response = await api.get<Note[]>(`/profiles/${profileId}/notes`);
    return response.data;
  },

  createRelationshipNote: async (profileId: string, data: NoteCreateDTO): Promise<Note> => {
    const response = await api.post<Note>(`/profiles/${profileId}/notes`, data);
    return response.data;
  },

  updateRelationshipNote: async (profileId: string, noteId: string, data: NoteUpdateDTO): Promise<Note> => {
    const response = await api.put<Note>(`/profiles/${profileId}/notes/${noteId}`, data);
    return response.data;
  },

  deleteRelationshipNote: async (profileId: string, noteId: string): Promise<void> => {
    await api.delete(`/profiles/${profileId}/notes/${noteId}`);
  },
};
